import { definePanel } from '@/app/definePanel';
import { KnownObjectsIcon } from '@/components/occurra/icons/KnownObjectsIcon';
import { PanelMode, PanelTheme } from '@/types/panels';

export default definePanel({
    id: 'enrolled_objects',
    title: 'Enrolled objects',
    description: 'People and vehicles enrolled by name. Open one to see each of its sightings.',
    icon: KnownObjectsIcon,
    // As the Objects panel, whose Known objects tab this is: the gallery keeps its width.
    width: { min: 480, default: 480, max: Infinity, fill: false },
    modes: [PanelMode.View],
    themes: PanelTheme.Any,
    isHeaderless: true,
    // Beside AI Search, which took the place of the Objects panel in the rail.
    order: 4.46,
    // The camera filter of the appearances.
    urlSyncedProps: ['cameraId'],
});
